var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-element"},[_c('div',{staticClass:"box-header"},[_vm._t("box-header")],2),_vm._v(" "),_vm._t("box-body")],2)}
var staticRenderFns = []

export { render, staticRenderFns }